var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.077 11.143c.738 0 1.406.3 1.89.783a2.673 2.673 0 0 1 .032 3.748l-6.947 7.189a1.407 1.407 0 0 0-.395.978v13.763a2.678 2.678 0 0 1-3.243 2.614l-3.452-1.812a4.303 4.303 0 0 1-2.22-3.766V23.88c0-.375-.149-.735-.415-.999l-7.228-7.168a2.665 2.665 0 0 1-.79-1.887 2.673 2.673 0 0 1 2.673-2.684Z",
    stroke: "currentColor",
    strokeWidth: 3.714
  }))));
};
export default SvgFilter;